
/**
 * Directory example - if git+bitbucket.org/lcms/folly$00df80968 is vendored in src/installed/folly/lib/
 * {
 *   locator: 'git+bitbucket.org/lcms/folly$00df80968'
 *   type: 'directory'
 *   name: 'lib'
 *   path: '/src/installed/folly/lib'
 * }
 * File example - if git+github.com/p-ranav/glob$v0.0.1 is vendored in src/installed/headers/glob.h
 * {
 *   locator: 'git+github.com/p-ranav/glob$v0.0.1'
 *   type: 'file'
 *   name: 'glob.h'
 *   path: '/src/installed/headers/glob.h'
 * }
 */
export type VendoredDependencyPath = {
  locator: string; // locator of the dependency
  type: 'directory' | 'file';
  name: string; // name of the directory or file where the dependency is vendored
  path: string; // path to the directory or file where the dependency is vendored
}

export type VendoredDependencyPathsResponse = {
  paths: VendoredDependencyPath[];
};

export enum DependencySource {
  Vendored = 'vendored', // Vendored dependency - source code copied directly into repo
  Managed = 'managed', // Managed dependency - imported (or included for SBOM projects)
}
